<style lang="scss" scoped>
.camera {
  width: 416px;
  height: 270px;
  margin-top: 20px;

  .plane {
    // padding-top: 5px;

    .visitor_table {
      margin-top: 20px;
      height: 184px;

      .table_head {
        // padding: 3px 20px;
        background: rgba(255, 255, 255, 0.1);
        display: grid;
        grid-template-columns: 1.5fr 1.5fr 1fr;
        place-items: center;
        height: 33px;
      }

      .table_body{
        .body-item{
        // padding: 0 20px;
        display: grid;
        grid-template-columns: 1.5fr 1.5fr 1fr;
        place-items: center;
        }
        .item-cell{
          font-size: 14px;
          height: 33px;
          line-height: 33px;
          display: grid;
          place-items: center;
        }
        .abnormal{
          div:nth-child(1){
            width: 100%;
            background: rgba(241, 56, 47, 0.2);
          }
          div:nth-child(2){
            width: 100%;
            background: rgba(241, 56, 47, 0.2);
          }
          div:nth-child(3){
            // padding: 0 5px;
            width: 100%;
            background-color: rgba(148, 37, 31, 1);
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="camera">
    <custom-plane title="访客管理" class="plane"
      :iconImg="require('@/assets/compImg/icon/visitor.png')">
      <div class="visitor_table">
        <div class="table_head">
          <div class="head_item" v-for="(item, index) in headData" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="table_body">
          <div class="body-item" v-for="(item, index) in visitorData"
            :key="index" :class="{abnormal:index==1}">
            <div v-for="(value,index) in item" :key="index">
              <div class="item-cell">
                {{ value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headData: ['入场时间', '出场时间', '访客ID'],
      visitorData:[
        {admissionTime:'2021-10-01 08:32:56',exFactoryTime:'-',ID:'B321122111'},
        {admissionTime:'2021-10-01 08:32:56',exFactoryTime:'-',ID:'B321122111'},
        {admissionTime:'2021-10-01 08:32:56',exFactoryTime:'-',ID:'B321122111'}
      ]
    }
  }
}
</script>